import axios from "axios";
import QueryString from "query-string";
const sessionStorageUser = "__nyu_bi_auth_provider_user__";
const client_id = "ikFmD4RiZCYtgKAZXxsMx64riHsa";
const dev_client_id = "Cim2dVfR5GkopObXZL7hhGB5Zosa";

const authURL = "https://auth.nyu.edu/oauth2";

const authProxyURL =
  "https://vrzy62aws9-vpce-068a21ad2a050c990.execute-api.us-east-1.amazonaws.com/dev/EDM-Dev-Auth-Proxy"; //Dev/QA API
const devAuthProxyURL =
  "https://8u6gr3dn2g.execute-api.us-east-1.amazonaws.com/Dev/EDM-DEV-Auth-Proxy"; // Sandbox Dev API

const logoutURL =
  "https://auth.nyu.edu/commonauth?commonAuthLogout=true&type=oidc2&commonAuthCallerPath=https://shibboleth.nyu.edu/idp/profile/Logout";

const mainURL = "https://data.nyu.edu/";
const devURL = "https://dev.data.nyu.edu/";

function getUserFromSessionStorage() {
  return JSON.parse(window.sessionStorage.getItem(sessionStorageUser));
}

function redirectToNYULobby(dev = false) {
  // return;
  logout();

  let authorizationURL =
    `${authURL}/authorize?` +
    QueryString.stringify({
      redirect_uri: dev ? devURL : mainURL,
      response_type: "code",
      scope: "openid",
      client_id: dev ? dev_client_id : client_id,
    });
  window.location.href = authorizationURL;

  if (!window.location.href.includes("code=")) {
    // replace will stop current program
    window.location.replace(authorizationURL);
    return;
  }
}

async function authenticate() {
  let url = new URL(window.location.href);

  //If no code param exist and no user in session storage, go to auth url
  //console.log(process.env.REACT_APP_DEVNETID);

  const DEV =
    window.location.href.indexOf("dev.data.nyu.edu") > -1 ? true : false;

  if (window.location.href.indexOf("localhost") > -1) {
    let netId = process.env.REACT_APP_DEVNETID ?? "fy2187"; // fan's netid for local testing
    let userInfo = {
      eduperson_primary_affiliation: "employee",
      firstname: netId,
      netid: netId,
      email: "no-email",
      lastname: "",
      expiry: new Date().getTime() + 30 * 60 * 1000,
      token:
        // Lei's token for local testing
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJsd20zIiwiZmlyc3RuYW1lIjoiTGVpIFdhbmciLCJuZXRpZCI6Imx3bTMiLCJlbWFpbCI6Imx3bTNAbnl1LmVkdSIsImVkdXBlcnNvbl9wcmltYXJ5X2FmZmlsaWF0aW9uIjoiZW1wbG95ZWUiLCJsYXN0bmFtZSI6Ik1pbGxtYW4iLCJpYXQiOjE3MTg3MTY5NzEsImV4cCI6MTcxODczODU3MX0.IK-Ly3V65Pd68As86otjRDWrt3G4DI0kzeZIDjweuOg",
        // alex's token
        // "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJqeDIwNzEiLCJmaXJzdG5hbWUiOiJBbGV4IiwibmV0aWQiOiJqeDIwNzEiLCJlbWFpbCI6Imp4MjA3MUBueXUuZWR1IiwibGFzdG5hbWUiOiJYdSIsImlhdCI6MTY4NzQ2ODUxM30.R2GaRwUiCQDjq6ZA6f__pSsk46qFn7t29yb0_zcgdp4",
    };
    window.sessionStorage.setItem(sessionStorageUser, JSON.stringify(userInfo));
    return userInfo;
  }

  if (
    !url.searchParams.has("code") &&
    window.sessionStorage.getItem(sessionStorageUser) === null
  ) {
    redirectToNYULobby(DEV);
    return;
  }

  //Example Return URL : https://bi.nyu.edu/reporting?state=af0ifjsldkjd&code=e836906123a7eb5dfcf53e39fb729eb2&awda=waeae
  let code = url.searchParams.get("code");

  let userInfo;

  let response = await axios.get(DEV ? devAuthProxyURL : authProxyURL, {
    params: {
      code,
    },
  });

  userInfo = response.data.data;
  userInfo.expiry = new Date().getTime() + 30 * 60 * 1000;
  window.sessionStorage.setItem(sessionStorageUser, JSON.stringify(userInfo));
  //after user stored in session storage,
  //redirect to main url to remove "code" and "session state" params
  window.location.href = DEV ? devURL : mainURL;

  return userInfo;
}

function logout() {
  window.sessionStorage.clear();
  window.location.replace(logoutURL);
}

export { getUserFromSessionStorage, authenticate, logout, sessionStorageUser };
